<template>
  <div class="pictured-section" :class="{'pictured-section--dark': dark}" v-if="data && (data.heading || data.description) ">
    <div class="container">
      <div class="row">
        <div
          class="col-l-4 col-m-4 col-s-12 pictured-section__image notched notched__enabled notched__outside notched__mobile-outside notched--middle notched--mobile-middle notched--dark-grey"
          v-if="data.image.url"
          :style="{ 'background-image': 'url( '+ data.image.url +' )' }"
        ><div class="notched-helper"></div></div>
        <div class="col-l-8 col-m-8 col-s-12 pictured-section__content">
          <div class="pictured-section__description" v-if="data.description" v-html="data.description">
            <!-- <p class="white">{{ data.description }}</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pictured-section",
  props: {
      data: Object,
      dark: {
          type: Boolean,
          default: true,
      },
      },
};
</script>


// WEBPACK FOOTER //
// PicturedSection.vue?0489cbae